import { Redirect } from 'expo-router';
import { Platform } from 'react-native';

import Quiltt from '../../../holistic/quiltt/Quiltt';

const ConnectInstitutionScreen = () => {
    if (Platform.OS === 'web') {
        return <Redirect href="/" />;
    }

    return <Quiltt />;
};

export default ConnectInstitutionScreen;
